import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Mail, CheckCircle } from 'lucide-react';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/auth/forgot-password`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email })
      });

      if (!response.ok) {
        const data = await response.json();
        throw new Error(data.detail || 'Erreur');
      }

      setSent(true);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  if (sent) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#F5F6F9] px-4">
        <div className="w-full max-w-md bg-white rounded-xl border border-[#BFC6CC] p-8 text-center">
          <div className="w-16 h-16 bg-[#10D183]/10 rounded-full flex items-center justify-center mx-auto mb-6">
            <CheckCircle className="w-8 h-8 text-[#10D183]" />
          </div>
          <h2 className="text-2xl font-heading font-semibold text-[#191D1E] mb-3" data-testid="forgot-password-success-title">Email envoyé</h2>
          <p className="text-[#687175] mb-6">
            Si un compte existe avec l'adresse <strong className="text-[#191D1E]">{email}</strong>, vous recevrez un lien de réinitialisation dans quelques instants.
          </p>
          <p className="text-sm text-[#687175] mb-6">
            Pensez à vérifier votre dossier spam si vous ne voyez pas l'email.
          </p>
          <Link
            to="/login"
            className="inline-flex items-center gap-2 text-[#397DFF] font-medium hover:underline"
            data-testid="back-to-login-link"
          >
            <ArrowLeft className="w-4 h-4" />
            Retour à la connexion
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#F5F6F9] px-4">
      <div className="w-full max-w-md bg-white rounded-xl border border-[#BFC6CC] p-8" data-testid="forgot-password-page">
        <div className="text-center mb-6">
          <div className="w-16 h-16 bg-[#F97316]/10 rounded-full flex items-center justify-center mx-auto mb-4">
            <Mail className="w-8 h-8 text-[#F97316]" />
          </div>
          <h2 className="text-2xl font-heading font-semibold text-[#191D1E] mb-2" data-testid="forgot-password-title">
            Mot de passe oublié
          </h2>
          <p className="text-[#687175] text-sm leading-relaxed">
            Pour des raisons de sécurité, la réinitialisation s'effectue via votre administrateur.
          </p>
        </div>

        <div className="bg-[#FAFBFC] border border-[#BFC6CC] rounded-lg p-4 mb-6 text-sm text-[#191D1E] space-y-2">
          <p className="font-medium">Pour récupérer l'accès à votre compte :</p>
          <ol className="list-decimal list-inside space-y-1.5 text-[#687175]">
            <li>Contactez votre administrateur (par téléphone ou messagerie interne)</li>
            <li>Il/elle générera un mot de passe temporaire pour vous</li>
            <li>Connectez-vous avec ce mot de passe temporaire</li>
            <li>Vous serez invité à le remplacer immédiatement par un mot de passe personnel</li>
          </ol>
        </div>

        <div className="text-center">
          <Link
            to="/login"
            className="inline-flex items-center gap-2 text-sm text-[#397DFF] hover:underline"
            data-testid="forgot-password-back-link"
          >
            <ArrowLeft className="w-4 h-4" />
            Retour à la connexion
          </Link>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
